import { render, staticRenderFns } from "./CandidateMatch.vue?vue&type=template&id=500ed2f1&scoped=true"
import script from "./CandidateMatch.vue?vue&type=script&lang=js"
export * from "./CandidateMatch.vue?vue&type=script&lang=js"
import style0 from "./CandidateMatch.vue?vue&type=style&index=0&id=500ed2f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500ed2f1",
  null
  
)

export default component.exports